import jwtDecode from "jwt-decode";
import sign from "jwt-encode";
import _ from "lodash";

const { REACT_APP_PRIVATE_SECRET_KEY } = process.env;

export const secretDecode = ({ jwtData }) => {
  const decode = _.replace(jwtData, REACT_APP_PRIVATE_SECRET_KEY, ".");
  return jwtDecode(decode);
};

export const secretEncode = ({ jwtData }) => {
  const jwt = sign(jwtData, "secret");
  const hash = _.replace(jwt, ".", REACT_APP_PRIVATE_SECRET_KEY);
  return hash;
};
